<template>
  <div class="light-blue-skin" style="font-family: OpenSans-Regular">
    <mdb-side-nav
      :OpenedFromOutside.sync="toggle"
      router
      :to="mainRoute"
      logo="https://myfrac-documents.s3-us-west-2.amazonaws.com/img/Logoenblanco%403x.png"
    >
      <ul>
        <li>
          <mdb-side-nav-nav>
            <!-- Dashboard -->
            <mdb-side-nav-item
              v-if="isAdmin || isAdminGeneral || isIntegrator || isCapturista || isVigilante"
              to="/home"
              :class="activeItem==0? colorSelectClass: ''"
              @click.native="toggle=false; activeItem=0;"
              icon="home"
              openIcon="home"
            >
              Dashboard
            </mdb-side-nav-item>

            <!-- Fraccionamientos -->
            <mdb-side-nav-item
              v-if="isIntegrator"
              to="/fracs"
              :class="activeItem==1? colorSelectClass: ''"
              @click.native="toggle=false; activeItem=1;"
              icon="cubes"
              openIcon="cubes"
            >
              Fraccionamientos
            </mdb-side-nav-item>

            <!-- Integradores -->
            <mdb-side-nav-item
              v-if="isAdminGeneral"
              to="/integrators"
              :class="activeItem==1? colorSelectClass: ''"
              @click.native="toggle=false; activeItem=1;"
              icon="user-tie"
              openIcon="user-tie"
            >
              Integradores
            </mdb-side-nav-item>

            <!-- Eventos masivos -->
            <mdb-side-nav-item
              v-if="isAdmin || isResident || isCapturista"
              to="/massiveEvents"
              :class="activeItem==1? colorSelectClass: ''"
              @click.native="toggle=false; activeItem=1;"
              icon="custom-icon-events"
              openIcon="custom-icon-events"
            >
              Eventos masivos
            </mdb-side-nav-item>

            <!-- Reportes -->
            <mdb-side-nav-cat
              v-if="isAdmin || isVigilante || isCapturista"
              name="Reportes"
              :class="activeItem==3? colorSelectClass: ''"
            >
              <mdb-side-nav-item
                v-if="isAdmin || isVigilante || isCapturista"
                to="/visitants"
                @click.native="toggle=false; activeItem=3"
                icon="file-signature"
              >
                Reporte visitas
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isVigilante || isCapturista"
                to="/commonAreaVisitants"
                @click.native="toggle=false; activeItem=3"
                icon="file-image"
              >
                Reporte áreas comunes
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isVigilante || isCapturista"
                to="/facialVisits"
                @click.native="toggle=false; activeItem=3"
                icon="id-card"
              >
                Reporte de Acceso Facial
              </mdb-side-nav-item>
            </mdb-side-nav-cat>

            <!-- Administración -->
            <mdb-side-nav-cat
              v-if="isAdmin || isAdminGeneral || isIntegrator || isCapturista"
              name="Administración"
              :class="activeItem==7? colorSelectClass: ''"
            >
              <mdb-side-nav-item
                v-if="isAdmin"
                to="/qrcodes"
                @click.native="toggle=false; activeItem=7"
                icon="tablet-alt"
              >
                <span>Dispositivos</span>
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isAdminGeneral || isIntegrator"
                to="/users"
                @click.native="toggle=false; activeItem=7"
                icon="users-cog"
              >
                Usuarios
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin"
                to="/providers"
                @click.native="toggle=false; activeItem=7"
                icon="custom-icon-providers"
              >
                Proveedores
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdminGeneral"
                to="/users-types"
                @click.native="toggle=false; activeItem=7"
                icon="users"
              >
                Tipos de usuarios
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdminGeneral"
                to="/carbrands"
                @click.native="toggle=false; activeItem=7"
                icon="car"
              >
                Marcas de vehículos
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdminGeneral"
                to="/colors"
                @click.native="toggle=false; activeItem=7"
                icon="palette"
              >
                Colores
              </mdb-side-nav-item>
            </mdb-side-nav-cat>

            <!-- Residentes (categoría separada, no anidada) -->
            <mdb-side-nav-cat
              v-if="isAdmin || isCapturista"
              name="Residentes"
              :class="isActiveGroup('/residents') ? colorSelectClass : ''"
            >
              <mdb-side-nav-item
                to="/residents/admin"
                @click.native="toggle=false;"
                icon="user-cog"
                :class="isActive('/residents/admin') ? colorSelectClass : ''"
              >
                Administración
              </mdb-side-nav-item>

              <mdb-side-nav-item
                to="/residents/faces"
                @click.native="toggle=false;"
                icon="id-badge"
                :class="isActive('/residents/faces') ? colorSelectClass : ''"
              >
                Carga faciales
              </mdb-side-nav-item>
            </mdb-side-nav-cat>

            <!-- Catálogos -->
            <mdb-side-nav-cat
              v-if="isAdmin || isCapturista"
              name="Catálogos"
              :class="activeItem==4? colorSelectClass: ''"
            >
              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/gates"
                @click.native="toggle=false; activeItem=4"
                icon="door-open"
              >
                Puertas de acceso
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/zones"
                @click.native="toggle=false; activeItem=4"
                icon="map-marker-alt"
              >
                Zonas
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/streets"
                @click.native="toggle=false; activeItem=4"
                icon="road"
              >
                Calles
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/commonareas"
                @click.native="toggle=false; activeItem=4"
                icon="tree"
              >
                Áreas comunes
              </mdb-side-nav-item>
            </mdb-side-nav-cat>

            <!-- Comunidad -->
            <mdb-side-nav-cat
              v-if="isAdmin || isCapturista"
              name="Comunidad"
              :class="activeItem==5? colorSelectClass: ''"
            >
              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/notices"
                @click.native="toggle=false; activeItem=5"
                icon="file-alt"
              >
                Avisos
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/newsletters"
                @click.native="toggle=false; activeItem=5"
                icon="envelope-open"
              >
                Boletines
              </mdb-side-nav-item>

              <mdb-side-nav-item
                v-if="isAdmin || isCapturista"
                to="/promotions"
                @click.native="toggle=false; activeItem=5"
                icon="tag"
              >
                Promociones
              </mdb-side-nav-item>
            </mdb-side-nav-cat>

            <!-- Ajustes -->
            <mdb-side-nav-item
              v-if="isAdmin"
              to="/configuration"
              :class="activeItem==6? colorSelectClass: ''"
              @click.native="toggle=false; activeItem=6"
              icon="custom-icon-ajustes"
              class="ajustes-class"
            >
              Ajustes
            </mdb-side-nav-item>
          </mdb-side-nav-nav>

          <span class="text-side">Copyright © 2020 Kiritek. Derechos Reservados.</span>
        </li>
      </ul>
    </mdb-side-nav>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import { mapGetters } from "vuex";
import * as firebase from "firebase/app";
import "firebase/database";
import {
  mdbContainer,
  mdbSideNav,
  mdbSideNavNav,
  mdbSideNavCat,
  mdbSideNavItem,
  mdbIcon,
  waves
} from "mdbvue";

export default {
  name: "SideNav",
  props: {
    waves: { type: Boolean, default: true },
    open: { type: Boolean }
  },
  components: {
    mdbContainer,
    mdbSideNav,
    mdbSideNavNav,
    mdbSideNavCat,
    mdbSideNavItem,
    mdbIcon,
    waves
  },
  data() {
    return {
      toggle: false,
      active: 0,
      elHeight: 0,
      windowHeight: 0,
      isResident: false,
      isContractor: false,
      isAdmin: false,
      isIntegrator: false,
      isAdminGeneral: false,
      isCapturista: false,
      isVigilante: false,
      dataBase: null,
      mainRoute: "/home",
      requestWorkers: [],
      pendingRequest: 0,
      colorSelectClass: "color-active",
      activeItem: 0
    };
  },
  methods: {
    afterEnter(el) { el.style.maxHeight = "1000px"; },
    beforeLeave(el) { el.style.maxHeight = 0; },

    checkSession() {
      const role = localStorage.getItem("role");
      if (role === "Contratista") {
        this.isContractor = true;
        this.mainRoute = "/constructions_contractor";
      } else if (role === "Residente") {
        this.isResident = true;
        this.mainRoute = "/massiveEvents";
      } else if (role == "Administrador de fraccionamiento") {
        this.isAdmin = true;
      } else if (role == "Administrador general") {
        this.isAdminGeneral = true;
      } else if (role == "Capturista") {
        this.isCapturista = true;
      } else if (role == "Vigilante" || role == "Vigilante administrativo") {
        this.isVigilante = true;
      } else {
        this.isIntegrator = true;
      }
    },

    getWorkerRequest() {
      Axios.get(
        Servers.serverApi + "api/constructionWorkerRequests/byAdministrator",
        {
          responseType: "application/json",
          headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        }
      )
        .then((response) => {
          this.requestWorkers = response.data || [];
          this.pendingRequest = this.requestWorkers.reduce(
            (acc, cur) => acc + (cur.status === "Pendiente" ? 1 : 0), 0
          );
        })
        .catch(error => {
          console.log(error && error.response && error.response.data);
        });
    },

    // === Helpers para marcar activos por ruta ===
    isActive(path) {
      return this.$route && this.$route.path === path;
    },
    isActiveGroup(prefix) {
      return this.$route && this.$route.path.startsWith(prefix);
    }
  },
  mounted() {
    this.checkSession();
    // this.getWorkerRequest(); // descomenta si lo usas
  },
  watch: {
    open() { this.toggle = true; },
    pendingRequest(newVal) { this.pendingRequest = newVal; }
  },
  computed: {
    ...mapGetters({ isMe: "getWhoAmi" })
  },
  mixins: [waves]
};
</script>

<style>
.text-side {
  position: absolute;
  bottom: 1rem;
  width: 100%;
  font-size: 11px;
  font-family: OpenSans-Regular;
  padding-left: 20px;
}

.ajustes-class {
  display: block;
  position: absolute;
  bottom: 4rem;
  width: 100%;
}

.side-nav .collapsible a {
  color: #424242;
}

.collapse-side-nav-item {
  overflow: hidden;
  max-height: 0;
  padding: 0;
  transition: max-height 0.3s;
}
.collapse-side-nav-item a {
  padding-left: 47px;
  line-height: 36px;
  background-color: rgba(0, 0, 0, 0.15);
}

.light-blue-skin .side-nav {
  background-color: rgb(169, 188, 206) !important;
}

.fa-custom-icon-events {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Calendar_icon@3x.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-contractor {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-construction {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Obra_Icon@3x.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-worker {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Trabajadores@3x.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-request {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/note_add@3x.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-ajustes {
  width: 18px;
  height: 18px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Ajustes_icon.png) !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
.fa-custom-icon-providers {
  width: 18px;
  height: 18px;
  background-image: url("../../static/providers.png") !important;
  background-size: 18px 18px !important;
  border: 0px !important;
}
</style>

<style scoped>
.side-nav .collapsible a {
  font-size: 0.9rem !important;
}

.color-active {
  color: #aadeff !important;
  background-color: rgba(0, 0, 0, 0.15) !important;
}

.lineaComunity {
  width: 70%;
  height: 1px;
  left: 20px;
  position: absolute;
  margin: 0 auto;
  background: #ffffff;
}

.headersTitle {
  font-size: 0.8rem;
  line-height: 26px;
  text-indent: 3.5rem;
  color: rgb(255, 255, 255);
  font-family: "OpenSans-Bold";
}
</style>
